var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcfx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_2483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9176 8.71873C12.6931 11.8483 9.51417 14.932 6.15625 18.2021C6.15625 16.5933 6.15625 15.2427 6.15625 13.8921C6.18713 13.6812 6.29078 13.4879 6.44908 13.346C9.60201 10.2917 12.7419 7.27332 15.9437 4.16016C17.0109 5.17064 18.0814 6.15822 19.1259 7.16868C21.1498 9.13076 23.1509 11.1255 25.1877 13.0778C25.3883 13.2543 25.5451 13.4753 25.6456 13.7234C25.7462 13.9715 25.7877 14.2398 25.7669 14.5069C25.7278 15.6678 25.7669 16.832 25.7669 18.248L15.9176 8.71873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47656 20.4641L15.9713 13.2549L18.0937 15.5001L13.3875 20.4447C14.213 21.3142 15.0808 22.2324 16.1534 23.3647C17.7362 21.5348 19.267 19.7569 20.801 17.9788L21.2756 18.1703L23.2777 20.6913L16.0201 27.6993L8.47656 20.4641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_2483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcfx);
export default __webpack_public_path__ + "static/media/tcfx.1892a010de6fa98c3e27b5995b64e3e5.svg";
export { ForwardRef as ReactComponent };